import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { VehicleBuyInDetailView } from "@/views/vehicle-buy-in-detail/vehicle-buy-in-detail.view";
import { Route, Switch } from "wouter";
import { VehicleBuyInCreateView } from "./create/vehicle-buy-in-create.view";
import { VehicleBuyInListView } from "./vehicle-buy-in-list.view";

export function VehicleBuyInRoutes() {
  const vehicleBuyInUuidRegex = generateUuidV4Regex({ paramName: "uuid" });

  return (
    <Switch>
      <Route path="/create" component={VehicleBuyInCreateView} />
      <Route path={vehicleBuyInUuidRegex} component={VehicleBuyInDetailView} />
      <Route path="/" component={VehicleBuyInListView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
